module.exports = __webpack_public_path__ + "img/basic-back.3dfbef99.png";